var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-info" }, [
    _c(
      "div",
      { staticClass: "main has-text-white", class: _vm.profileBoxStyle },
      [
        _c(
          "div",
          {
            staticClass: "basic-info columns",
            staticStyle: { position: "relative" }
          },
          [
            _c("div", { staticClass: "profile-pic column is-narrow" }, [
              _c("div", { staticClass: "profile-pic-box" }, [
                _vm.studentProfile.student.avatar && !_vm.avatarFailed
                  ? _c("div", [
                      _c("img", {
                        staticClass: "profile-avatar-img",
                        attrs: { src: _vm.studentProfile.student.avatar },
                        on: { error: _vm.disableAvatar }
                      })
                    ])
                  : _c("div", [_c("male-avatar")], 1)
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-info-content column" }, [
              _c("p", { staticClass: "student-id fs-13" }, [
                _vm._v(_vm._s(_vm.studentProfile.student.code))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "student-firstname fs-20 is-uppercase" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.navigateTo("app.profile")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.studentProfile.student.name))]
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "student-program fs-13 is-capitalized" }, [
                _vm._v(_vm._s(_vm.formattedProgramLine))
              ])
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "edit-btn",
                staticStyle: {
                  position: "absolute",
                  top: "0px",
                  right: "10px"
                },
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.navigateTo("app.profile.change_situation")
                  }
                }
              },
              [
                _c("edit-icon", {
                  staticStyle: { width: "1.5em", height: "1.5em" }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "risk-level-info" }, [
          _c(
            "span",
            {
              staticClass: "risk-level-indicator is-size-4 has-text-weight-bold"
            },
            [
              _c(
                "span",
                {
                  staticClass: "risk-level-indicator-arrow at-risk",
                  staticStyle: { visibility: "hidden" }
                },
                [_c("arrow-icon")],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "risk-level-value fs-26" }, [
            _vm._v(
              _vm._s(
                _vm._f("percentage")(
                  _vm.studentProfile.student.desertionProbability
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "risk-level-description fs-13" }, [
            _vm._v(_vm._s(_vm.riskDescription))
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "contact has-background-white" }, [
      _c(
        "div",
        { staticClass: "contact-basic" },
        [
          _c("h4", { staticClass: "has-text-weight-medium is-marginless" }, [
            _vm._v("CONTACTO")
          ]),
          _vm._v(" "),
          _vm._l(_vm.studentProfile.student.phoneNumbers, function(
            item,
            index
          ) {
            return _c("div", { staticClass: "contact-item" }, [
              _c(
                "span",
                {
                  staticClass: "contact-item-icon",
                  class: { invisible: index != 0 }
                },
                [_c("telephone-icon")],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "contact-item-value",
                  attrs: { href: _vm.callTo(item) }
                },
                [_vm._v(_vm._s(item))]
              )
            ])
          }),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "7px" } }),
          _vm._v(" "),
          _vm._l(_vm.studentProfile.student.emailAddresses, function(
            item,
            index
          ) {
            return _c("div", { staticClass: "contact-item" }, [
              _c(
                "span",
                {
                  staticClass: "contact-item-icon",
                  class: { invisible: index != 0 }
                },
                [_c("mail-icon")],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "contact-item-value",
                  attrs: { href: _vm.mailTo(item) }
                },
                [_vm._v(_vm._s(item))]
              )
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "student-enrollment" }, [
        _c("h4", { staticClass: "has-text-weight-medium is-marginless" }, [
          _vm._v("MATRÍCULA")
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.enrolledSinceText))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "student-responsible" }, [
        _c("h4", { staticClass: "has-text-weight-medium is-marginless" }, [
          _vm._v("RESPONSABLE")
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.responsibleName))])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "more-info has-text-grey has-background-white fs-14" },
      [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.navigateTo("app.profile.info")
              }
            }
          },
          [_vm._v("+ Más información")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }